<template lang="pug">
  .pdp-carousel
    .carousel-nav-wrap.xs-hide.sm-hide(:class="{'has-arrows': hasArrows}")
      button.top-nav.btn-reset(v-if="hasArrows" type="button" @click="prev")
        span.icon-caret-up.color-slate.xs-f-large.max-at-tweak
          span.ada-tooltip previous

      slick.slider-nav(v-if="images.length > 1" :class="navClass" ref="slickNav" :options="carouselNavOptions")
        .slide(v-for="image in images")
          .img.a-box-xs-1x1
            .a-box-content.bg-fog-light
              template(v-if="image.file_type == 'mp4'")
                img.full-width.v-center(:src="image.video_thumb" :alt="image.alt_text")
              template(v-else)
                img.full-width(:src="image.url" :alt="image.alt_text")

      button.bottom-nav.btn-reset(v-if="hasArrows" type="button" @click="next")
        span.icon-caret-down.color-slate.xs-f-large.max-at-tweak
          span.ada-tooltip next

    .carousel-wrap
      slick.slider-for(:class="carouselClass" ref="slick" :options="carouselOptions")
        .slide(v-for="(image, index) in images")
          .img.a-box-xs-1x1
            .a-box-content.bg-fog-light
              template(v-if="image.file_type == 'mp4'")
                video.full-width.v-center(:src="image.url" :poster="image.video_thumb" :alt="image.alt_text" controls)
              template(v-else)
                img.full-width(:src="image.url" :alt="image.alt_text")
              
              slot(v-if="index == 0" name="first-image")

      slot

      .left-nav(@click="prev")
        span.ada-tooltip previous
      .right-nav(@click="next")
        span.ada-tooltip next
  
</template>

<script>
  const debounce = require("debounce");

  export default {
    name: "PdpCarousel",

    props: {
      images: {
        type: Array,
        default: []
      }
    },

    data() {
      return {
        windowWidth: 0,
        show: false
      }
    },

    computed: {
      navClass() {
        return 'slider-nav-' + this._uid;
      },

      carouselClass() {
        return 'slider-for-' + this._uid;
      },

      carouselNavOptions() {
        return {
          slidesToShow: 5,
          slidesToScroll: 1,
          focusOnSelect: true,
          vertical: true,
          infinite: false,
          asNavFor: '.' + this.carouselClass,
        }
      },

      carouselOptions() {
        return {
          slidesToShow: 1,
          fade: true,
          infinite: false,
          dots: false,
          arrows: false,
          asNavFor: '.' + this.navClass,
          responsive: [
            {
              breakpoint: 760,
              settings: {
                fade: false,
                infinite: true
              }
            }
          ]
        }
      },

      hasArrows() {
        return this.images.length > 5;
      }
    },

    watch: {
      images(val) {
        this.$nextTick(() => {
          if (this.$refs.slickNav) {
            this.$refs.slickNav.reSlick();
          }
          if (this.$refs.slickNav) {
            this.$refs.slick.reSlick();
          }
        });
      }
    },

    methods: {
      next() {
        this.$refs.slick.next();
      },

      prev() {
        this.$refs.slick.prev();
      },

      reInit: debounce(function() {
        var newWidth = $(window).width();

        if (this.windowWidth != newWidth) {
          this.windowWidth = newWidth;
          if (this.$refs.slickNav) {
            this.$refs.slickNav.reSlick();
          }
          if (this.$refs.slickNav) {
            this.$refs.slick.reSlick();
          }
        }
      }, 500)
    },

    mounted() {
      this.windowWidth = $(window).width();
      window.addEventListener('resize', this.reInit);
    }
  }
</script>

<style lang="stylus">
  .pdp-carousel
    width 100%
    overflow hidden
    
    .carousel-nav-wrap
    .carousel-wrap
      position relative
      display inline-block
      vertical-align top
      
      .slick-slider
        margin-bottom 0
      
      .slide
        vertical-align middle
        padding 0.3em
        
    .carousel-nav-wrap
      .slider-nav
        .slide
          &.slick-current
            .img
              &:after
                content ''
                position absolute
                top 0
                right 0
                bottom 0
                left 0
                border 3px solid color-mr-blue
      
      .top-nav
      .bottom-nav
        display block
        width 100%
        text-align center

    @media mq-mobile
      .carousel-wrap
        display block
        width 80%
        margin 0 auto
        
        .left-nav
        .right-nav
          position absolute
          width 10%
          top 0
          bottom 0
          
        .left-nav
          left -10%
          
        .right-nav
          right -10%
        
        .slider-for
          overflow visible !important
          
          .slick-list
            overflow visible !important
    
    @media mq-tablet
      .carousel-wrap
        display block
        width 60%
        margin 0 auto
        
        .left-nav
        .right-nav
          position absolute
          width 10%
          top 0
          bottom 0
          
        .left-nav
          left 0
          
        .right-nav
          right 0
        
        .slider-for
          overflow visible !important
          
          .slick-list
            overflow visible !important
    
    @media mq-desktop-md-plus
      .carousel-nav-wrap
        width 20%
        padding-left 2%
        padding-right 2%
        
        &.has-arrows
          padding-left 4%
      
      .carousel-wrap
        width 80%
        
        .left-nav
        .right-nav
          display none
        
</style>
